import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

export const more = {
  icon: 'Plus',
  text: 'More',
};
export const less = {
  icon: 'Minus',
  text: 'Less',
};

export default function MoreLessButton(props) {
  const { tagsCount, expandSearchOptions, onToggleSearchOptions } = props;

  if (tagsCount <= 1) {
    return null;
  }

  const { icon, text } = expandSearchOptions ? less : more;

  return (
    <ButtonWithIcon
      type="link"
      size="small"
      linkIconSize="s"
      sprite={icon}
      iconRight
      onClick={onToggleSearchOptions}
      className="tree-view-dialog-selected-search-items-more-less-button e2e-more-less"
      aria-label={text}>
      {text}
    </ButtonWithIcon>
  );
}

MoreLessButton.propTypes = {
  tagsCount: PropTypes.number.isRequired,
  expandSearchOptions: PropTypes.bool.isRequired,
  onToggleSearchOptions: PropTypes.func.isRequired,
};
